import { render, staticRenderFns } from "./RequestValidationModal.vue?vue&type=template&id=5a68a3b5"
import script from "./RequestValidationModal.vue?vue&type=script&lang=js"
export * from "./RequestValidationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports